import ky from './kyextended';
import { CHANGE_PASSWORD_URL, CUMULATIVE_DASHBOARD, PROFILE_URL, RESET_PASSWORD_URL } from '../constants/APIConstants';


const changePassword = (passwords) =>  ky.post(CHANGE_PASSWORD_URL, {
    json: {...passwords, email: localStorage.getItem('email')},
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const resetPassword = (email) => ky.post(RESET_PASSWORD_URL, {
    json: email,
}).json();



const getProfile = () => ky.get(PROFILE_URL, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateProfile = (userDetails) => ky.patch(PROFILE_URL, {
    json: {user: userDetails},
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const cumulativeDashboard = () => ky.get(CUMULATIVE_DASHBOARD, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json()

export { changePassword, resetPassword, getProfile, updateProfile, cumulativeDashboard }; 